/* eslint-disable no-lone-blocks */
/* eslint-disable no-case-declarations */
/* eslint-disable indent */
/* eslint-disable camelcase */
import { nanoid } from 'nanoid'
import { cloneDeep, first } from 'lodash'
import store from '../../store'
import {
  BUFFER_QUALITY,
  BUFFER_QUALITY_VALUES,
  COMFORT_ZONE_WIDTH,
  COMFORT_ZONE_WIDTH_VALUES,
  CROSSING_IMPROVEMENTS,
  CROSSING_IMPROVEMENTS_VALUES,
  LIGHTING,
  LIGHTING_VALUES,
  PEDESTRIAN_FACILITY_TYPE,
  PEDESTRIAN_FACILITY_TYPE_VALUES,
  USABLE_SIDEWALK_WIDTH,
  USABLE_SIDEWALK_WIDTH_VALUES
} from '../constants/pedestrian'
import {
  HIGH_CAPACITY_TRANSIT_FACILITY_VALUES,
  TRANSIT_STOP_AMENITIES_VALUES
} from '../constants/transit'
import {
  addMultipleSegments,
  addSegment,
  removeAllMatchingSegments,
  removeAllMatchingSegmentsWithVariant,
  removeAllSimilarSegmentNames,
  updateFinalStreet
} from './multimodal.utils'
import {
  BIKE_FACILITY_TYPE,
  BIKE_FACILITY_TYPE_VALUES
} from '../constants/bike'
import { setBicycleInputs } from '../slices/criteriaSelection/bicycle'
import { setbikeStreetmixInput } from './bikeStreetmixInput.utils'

export function setPedestrianStreetmixInput(field) {
  const { pedestrian, street, modalTiers, transit, bicycle } = store.getState()
  const { transit_stop_amenities, high_capacity_transit_facility } = transit
  const {
    pedestrian_facility_type,
    comfort_zone_width,
    lighting,
    crossing_improvements,
    usable_sidewalk_width,
    buffer_quality
  } = pedestrian
  const { bike_facility_type } = bicycle
  const { Pedestrian: PTier } = modalTiers
  const { segments } = street

  switch (field) {
    case PEDESTRIAN_FACILITY_TYPE:
    case USABLE_SIDEWALK_WIDTH:
      let bikeLaneHasBuffer = false
      // Check if input is NO Sidewalk
      if (pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[2]) {
        let segmentCopy = cloneDeep(segments)
        segmentCopy = removeAllMatchingSegments(segmentCopy, 'sidewalk')

        // adjust street width, combine all extra planting strips
        segmentCopy = combineAdjacentPlantingStrips(segmentCopy)

        updateFinalStreet(segmentCopy)
      } else {
        bikeLaneHasBuffer =
          bike_facility_type === BIKE_FACILITY_TYPE_VALUES[2] ||
          bike_facility_type === BIKE_FACILITY_TYPE_VALUES[4]
        let segmentCopy = cloneDeep(segments)

        segmentCopy = removeAllMatchingSegments(segmentCopy, 'sidewalk')

        // remove all planting strips less than equal to 4
        // segmentCopy = removeAllMatchingSegmentsWithVariantAndWidth(
        //   segmentCopy,
        //   'divider',
        //   'planting-strip',
        //   4
        // )
        segmentCopy = removeAllMatchingSegmentsWithVariant(
          segmentCopy,
          'divider',
          'big-tree'
        )
        segmentCopy = removeAllMatchingSegmentsWithVariant(
          segmentCopy,
          'divider',
          'striped-buffer'
        )
        segmentCopy = removeAllMatchingSegments(segmentCopy, 'parking-lane')
        let sidewalk = {
          type: 'sidewalk',
          variantString: 'dense',
          width: 6,
          elevation: 1
        }

        // Determine width of sidewalk based on usable sidewalk width
        if (usable_sidewalk_width === USABLE_SIDEWALK_WIDTH_VALUES[0]) {
          sidewalk = {
            ...sidewalk,
            width: 10
          }
        } else if (usable_sidewalk_width === USABLE_SIDEWALK_WIDTH_VALUES[1]) {
          sidewalk = {
            ...sidewalk,
            width: 8
          }
        } else if (usable_sidewalk_width === USABLE_SIDEWALK_WIDTH_VALUES[2]) {
          sidewalk = {
            ...sidewalk,
            width: 6
          }
        } else if (usable_sidewalk_width === USABLE_SIDEWALK_WIDTH_VALUES[3]) {
          sidewalk = {
            ...sidewalk,
            width: 5
          }
        }

        let plantingStrip = {
          type: 'divider',
          variantString: 'planting-strip',
          width: 4,
          elevation: 1
        }
        const parkingLaneInbound = {
          type: 'parking-lane',
          variant: {
            'parking-lane-direction': 'inbound',
            'parking-lane-orientation': 'left'
          },
          variantString: 'inbound|left',
          width: 6
        }
        const parkingLaneOutbound = {
          type: 'parking-lane',
          variant: {
            'parking-lane-direction': 'outbound',
            'parking-lane-orientation': 'right'
          },
          variantString: 'outbound|right',
          width: 6
        }

        // Update plantingStrip based on buffer quality
        // if (buffer_quality === BUFFER_QUALITY_VALUES[0]) {
        //   // Big Tree
        //   plantingStrip = {
        //     ...plantingStrip,
        //     variantString: 'big-tree'
        //   }
        // } else if (buffer_quality === BUFFER_QUALITY_VALUES[1]) {
        //   // Physical Barrier/ Parked Car
        //   plantingStrip = parkingLaneInbound
        // } else if (buffer_quality === BUFFER_QUALITY_VALUES[2]) {
        //   // Striped buffer
        //   plantingStrip = {
        //     ...plantingStrip,
        //     variantString: 'striped-buffer',
        //     elevation: 0
        //   }
        // }
        // Check if buffer quality has a value
        let isBufferQuality = false
        if (
          buffer_quality === BUFFER_QUALITY_VALUES[0] ||
          buffer_quality === BUFFER_QUALITY_VALUES[1] ||
          buffer_quality === BUFFER_QUALITY_VALUES[2]
        ) {
          isBufferQuality = true
        }
        let firstLaneIndex = segmentCopy.findIndex(
          (segment) =>
            segment?.type?.indexOf('lane') !== -1 &&
            segment?.type?.indexOf('parking-lane') === -1
        )
        const rightLamp = {
          type: 'sidewalk-lamp',
          variant: {
            'lamp-orientation': 'right',
            'lamp-type': 'traditional'
          },
          variantString: 'right|traditional',
          width: 2,
          elevation: 1
        }
        const lefttLamp = {
          type: 'sidewalk-lamp',
          variant: {
            'lamp-orientation': 'left',
            'lamp-type': 'traditional'
          },
          variantString: 'left|traditional',
          width: 2,
          elevation: 1
        }
        const shelter = {
          type: 'transit-shelter',
          width: 9,
          elevation: 1
        }

        const bikeRack = {
          type: 'sidewalk-bike-rack',
          width: 5,
          elevation: 1
        }
        const sidewalkBench = {
          type: 'sidewalk-bench',
          width: 4,
          elevation: 1
        }

        // If lanes do not exist, add sidewalk to the end of the street
        if (firstLaneIndex === -1) {
          // if lanes do not exsist add the lanes
          const driveLane = {
            type: 'drive-lane',
            width: 10,
            variantString: 'inbound|car',
            variant: {
              direction: 'inbound',
              'car-type': 'car'
            },
            elevation: 0
          }
          const toBeAddedSegments = [
            { ...driveLane, id: nanoid() },
            {
              ...driveLane,
              variantString: 'outbound|car',
              variant: { ...driveLane.variant, direction: 'outbound' },
              id: nanoid()
            }
          ]
          segmentCopy = addMultipleSegments(
            toBeAddedSegments,
            Math.floor(segmentCopy.length / 2),
            segmentCopy
          )
          // Since new lanes are being added, update firstLaneIndex
          firstLaneIndex = segmentCopy.findIndex(
            (segment) =>
              segment?.type?.indexOf('lane') !== -1 &&
              segment?.type?.indexOf('parking-lane') === -1
          )
        }
        // if the segment includes lamp
        if (
          segmentCopy.some((segment) => segment?.type.includes('lamp')) === true
        ) {
          // DETACHED SIDEWALK + lamp
          if (pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[0]) {
            // Remove all lamps
            segmentCopy = removeAllSimilarSegmentNames(segmentCopy, 'lamp')

            // Remove all bike racks if any
            segmentCopy = removeAllMatchingSegments(
              segmentCopy,
              'sidewalk-bike-rack'
            )

            // Remove all shelters if any
            segmentCopy = removeAllMatchingSegments(
              segmentCopy,
              'transit-shelter'
            )
            // Remove all benches
            segmentCopy = removeAllMatchingSegments(
              segmentCopy,
              'sidewalk-bench'
            )

            // Calculate first lane index again, becuase you removed lamp
            firstLaneIndex = segmentCopy.findIndex(
              (segment) =>
                segment?.type?.indexOf('lane') !== -1 &&
                segment?.type?.indexOf('parking-lane') === -1
            )
            let toBeAddedSegments = []

            // ------ COMMENT OUT LIGHTING

            // if (lighting === LIGHTING_VALUES[0]) {
            //   // Pedestrian Lamp
            //   toBeAddedSegments = [
            //     { ...sidewalk, id: nanoid() },
            //     {
            //       ...lefttLamp,
            //       id: nanoid()
            //     },
            //     { ...plantingStrip, id: nanoid() }
            //   ]
            // } else if (lighting === LIGHTING_VALUES[1]) {
            //   // Road Lamp
            //   toBeAddedSegments = isBufferQuality
            //     ? [
            //         { ...sidewalk, id: nanoid() },
            //         {
            //           ...rightLamp,
            //           id: nanoid(),
            //           variantString: 'right|modern',
            //           variant: { ...rightLamp.variant, 'lamp-type': 'modern' }
            //         },
            //         { ...plantingStrip, id: nanoid() }
            //       ]
            //     : [
            //         { ...sidewalk, id: nanoid() },
            //         { ...plantingStrip, id: nanoid() },
            //         {
            //           ...rightLamp,
            //           id: nanoid(),
            //           variantString: 'right|modern',
            //           variant: { ...rightLamp.variant, 'lamp-type': 'modern' }
            //         }
            //       ]
            // }

            // ------ COMMENT OUT ALL TRANSIT AMENITIES
            {
              /**

            // if transit has bike rack
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[8])
            ) {
              toBeAddedSegments.splice(1, 0, {
                ...bikeRack,
                variantString: 'left|sidewalk-parallel',
                variant: {
                  orientation: 'left',
                  'bike-rack-elevation': 'sidewalk-parallel'
                },
                id: nanoid()
              })
            }

            // if transit has Bench
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[7])
            ) {
              toBeAddedSegments.splice(1, 0, {
                ...sidewalkBench,
                variantString: 'left',
                variant: { 'bench-orientation': 'left' },
                id: nanoid()
              })
            }

            // if transit has shelter
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[1])
            ) {
              toBeAddedSegments.splice(1, 0, {
                ...shelter,
                variantString: 'left|street-level',
                variant: {
                  orientation: 'left',
                  'transit-shelter-elevation': 'street-level'
                },
                id: nanoid()
              })
            }
            **/
            }
            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              firstLaneIndex,
              segmentCopy
            )
          } else if (
            // ATTACHED SIDEWALK + with lamp
            pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[1]
          ) {
            // if sidewalk is attached , remove all bike lanes and attached buffers
            if (bike_facility_type !== BIKE_FACILITY_TYPE_VALUES[0]) {
              // if bike lane has no buffer, remove all bike lanes
              segmentCopy = removeAllMatchingSegments(segmentCopy, 'bike-lane')
            }
            // if sidewalk is attached , remove all bus lanes
            if (
              high_capacity_transit_facility ===
                HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[0] ||
              high_capacity_transit_facility ===
                HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[1]
            ) {
              // if bike lane has no buffer, remove all bus lanes
              //   segmentCopy = removeAllMatchingSegments(segmentCopy, 'bus-lane')
              // if bike lane has no buffer, remove all bus rapid transit lanes
              //  segmentCopy = removeAllMatchingSegments(segmentCopy, 'brt-lane')
            }
            // Remove all lamps
            segmentCopy = removeAllSimilarSegmentNames(segmentCopy, 'lamp')

            // Remove all bike racks if any
            segmentCopy = segmentCopy = removeAllMatchingSegments(
              segmentCopy,
              'sidewalk-bike-rack'
            )

            // Remove all shelters if any
            segmentCopy = removeAllMatchingSegments(
              segmentCopy,
              'transit-shelter'
            )
            // Remove all benches
            segmentCopy = removeAllMatchingSegments(
              segmentCopy,
              'sidewalk-bench'
            )

            const firstLaneIndex = segmentCopy.findIndex(
              (segment) =>
                segment?.type?.indexOf('lane') !== -1 &&
                segment?.type?.indexOf('parking-lane') === -1
            )
            let toBeAddedSegments = []

            // ------ COMMENT OUT ALL TRANSIT AMENITIES
            {
              /**

            // if transit has shelter
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[1])
            ) {
              toBeAddedSegments = [
                {
                  ...shelter,
                  variantString: 'left|street-level',
                  variant: {
                    orientation: 'left',
                    'transit-shelter-elevation': 'street-level'
                  },
                  id: nanoid()
                }
              ]
            }
            // if transit has Bench
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[7])
            ) {
              toBeAddedSegments = [
                ...toBeAddedSegments,
                {
                  ...sidewalkBench,
                  variantString: 'left',
                  variant: { 'bench-orientation': 'left' },
                  id: nanoid()
                }
              ]
            }
            // if transit has bike rack
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[8])
            ) {
              toBeAddedSegments = [
                ...toBeAddedSegments,
                {
                  ...bikeRack,
                  variantString: 'left|sidewalk-parallel',
                  variant: {
                    orientation: 'left',
                    'bike-rack-elevation': 'sidewalk-parallel'
                  },
                  id: nanoid()
                }
              ]
            }

          **/
            }

            // ------ COMMENT OUT LIGHTING

            // if (lighting === LIGHTING_VALUES[0]) {
            //   // Pedestrian Lamp
            //   toBeAddedSegments = [
            //     ...toBeAddedSegments,
            //     { ...sidewalk, id: nanoid() },

            //     {
            //       ...lefttLamp,
            //       id: nanoid()
            //     }
            //   ]
            // } else if (lighting === LIGHTING_VALUES[1]) {
            //   // Road Lamp
            //   toBeAddedSegments = [
            //     ...toBeAddedSegments,
            //     { ...sidewalk, id: nanoid() },
            //     {
            //       ...rightLamp,
            //       id: nanoid(),
            //       variantString: 'right|modern',
            //       variant: { ...rightLamp.variant, 'lamp-type': 'modern' }
            //     }
            //   ]
            // }

            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              firstLaneIndex,
              segmentCopy
            )
          }
        } else {
          // No lamp + Detahced
          if (pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[0]) {
            const toBeAddedSegments = [
              { ...sidewalk, id: nanoid() },
              { ...plantingStrip, id: nanoid() }
            ]

            // Remove all bike racks if any
            segmentCopy = removeAllMatchingSegments(
              segmentCopy,
              'sidewalk-bike-rack'
            )
            // Remove all shelters if any
            segmentCopy = removeAllMatchingSegments(
              segmentCopy,
              'transit-shelter'
            )
            // Remove all benches
            segmentCopy = removeAllMatchingSegments(
              segmentCopy,
              'sidewalk-bench'
            )

            const firstLaneIndex = segmentCopy.findIndex(
              (segment) =>
                segment?.type?.indexOf('lane') !== -1 &&
                segment?.type?.indexOf('parking-lane') === -1
            )

            // ------ COMMENT OUT ALL TRANSIT AMENITIES
            {
              /**
            // if transit has bike rack
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[8])
            ) {
              toBeAddedSegments.splice(1, 0, {
                ...bikeRack,
                variantString: 'left|sidewalk-parallel',
                variant: {
                  orientation: 'left',
                  'bike-rack-elevation': 'sidewalk-parallel'
                },
                id: nanoid()
              })
            }

            // if transit has Bench
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[7])
            ) {
              toBeAddedSegments.splice(1, 0, {
                ...sidewalkBench,
                variantString: 'left',
                variant: { 'bench-orientation': 'left' },
                id: nanoid()
              })
            }

            // if transit has shelter
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[1])
            ) {
              toBeAddedSegments.splice(1, 0, {
                ...shelter,
                variantString: 'left|street-level',
                variant: {
                  orientation: 'left',
                  'transit-shelter-elevation': 'street-level'
                },
                id: nanoid()
              })
            }
          **/
            }
            const insertAtIndex = firstLaneIndex

            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              insertAtIndex,
              segmentCopy
            )
          } else if (
            pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[1]
          ) {
            // Attached sidewalk without lamp
            // if sidewalk is attached , remove all bike lanes and attached buffers
            if (bike_facility_type !== BIKE_FACILITY_TYPE_VALUES[0]) {
              segmentCopy = removeAllMatchingSegments(segmentCopy, 'bike-lane')
            }
            // if sidewalk is attached , remove all bus lanes
            if (
              high_capacity_transit_facility ===
                HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[0] ||
              high_capacity_transit_facility ===
                HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[1]
            ) {
              // if bus lane has no buffer, remove all bus lanes
              //  segmentCopy = removeAllMatchingSegments(segmentCopy, 'bus-lane')
              // if bus lane has no buffer, remove all brt lanes
              //  segmentCopy = removeAllMatchingSegments(segmentCopy, 'brt-lane')
            }
            // Remove all bike racks if any
            segmentCopy = segmentCopy = removeAllMatchingSegments(
              segmentCopy,
              'sidewalk-bike-rack'
            )

            // Remove all shelters if any
            segmentCopy = removeAllMatchingSegments(
              segmentCopy,
              'transit-shelter'
            )

            // Remove all benches
            segmentCopy = removeAllMatchingSegments(
              segmentCopy,
              'sidewalk-bench'
            )
            let toBeAddedSegments = []

            // ------ COMMENT OUT ALL TRANSIT AMENITIES
            {
              /**
            // if transit has shelter
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[1])
            ) {
              toBeAddedSegments = [
                {
                  ...shelter,
                  variantString: 'left|street-level',
                  variant: {
                    orientation: 'left',
                    'transit-shelter-elevation': 'street-level'
                  },
                  id: nanoid()
                }
              ]
            }
            // if transit has Bench
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[7])
            ) {
              toBeAddedSegments = [
                ...toBeAddedSegments,
                {
                  ...sidewalkBench,
                  variantString: 'left',
                  variant: { 'bench-orientation': 'left' },
                  id: nanoid()
                }
              ]
            }
            // if transit has bike rack
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[8])
            ) {
              toBeAddedSegments = [
                ...toBeAddedSegments,
                {
                  ...bikeRack,
                  variantString: 'left|sidewalk-parallel',
                  variant: {
                    orientation: 'left',
                    'bike-rack-elevation': 'sidewalk-parallel'
                  },
                  id: nanoid()
                }
              ]
            }
          **/
            }

            const firstLaneIndex = segmentCopy.findIndex(
              (segment) =>
                segment?.type?.indexOf('lane') !== -1 &&
                segment?.type?.indexOf('parking-lane') === -1
            )
            toBeAddedSegments = [
              ...toBeAddedSegments,
              { ...sidewalk, id: nanoid() }
            ]

            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              firstLaneIndex,
              segmentCopy
            )
          }
        }
        // Reverse segments to find last lane id
        const copyOfSegmentsToReverse = [...segmentCopy]

        const lastLaneId = copyOfSegmentsToReverse
          .reverse()
          .find(
            (segment) =>
              segment?.type?.indexOf('lane') !== -1 &&
              segment?.type?.indexOf('parking-lane') === -1
          )?.id

        const lastLandeIndex = segmentCopy.findIndex(
          (segment) => segment?.id === lastLaneId
        )
        // For last part of segment add outbound parked car
        if (buffer_quality === BUFFER_QUALITY_VALUES[1]) {
          // Physical Barrier/ Parked Car
          plantingStrip = parkingLaneOutbound
        }

        if (
          segmentCopy.some((segment) => segment?.type?.includes('lamp')) ===
          true
        ) {
          if (pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[0]) {
            let toBeAddedSegments = []
            // ------ COMMENT OUT LIGHTING
            // if (lighting === LIGHTING_VALUES[0]) {
            //   // Pedestrian Lamp
            //   toBeAddedSegments = [
            //     { ...plantingStrip, id: nanoid() },
            //     {
            //       ...rightLamp,
            //       id: nanoid()
            //     },
            //     { ...sidewalk, id: nanoid() }
            //   ]
            // } else if (lighting === LIGHTING_VALUES[1]) {
            //   // Road Lamp
            //   toBeAddedSegments = isBufferQuality
            //     ? [
            //         { ...plantingStrip, id: nanoid() },
            //         {
            //           ...lefttLamp,
            //           id: nanoid(),
            //           variantString: 'left|modern',
            //           variant: { ...lefttLamp.variant, 'lamp-type': 'modern' }
            //         },
            //         { ...sidewalk, id: nanoid() }
            //       ]
            //     : [
            //         {
            //           ...lefttLamp,
            //           id: nanoid(),
            //           variantString: 'left|modern',
            //           variant: { ...lefttLamp.variant, 'lamp-type': 'modern' }
            //         },
            //         { ...plantingStrip, id: nanoid() },
            //         { ...sidewalk, id: nanoid() }
            //       ]
            // }

            // ------ COMMENT OUT ALL TRANSIT AMENITIES
            {
              /**
            // if transit has bike rack
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[8])
            ) {
              toBeAddedSegments.splice(2, 0, {
                ...bikeRack,
                variantString: 'right|sidewalk-parallel',
                variant: {
                  orientation: 'right',
                  'bike-rack-elevation': 'sidewalk-parallel'
                },
                id: nanoid()
              })
            }
            // if transit has Bench
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[7])
            ) {
              toBeAddedSegments.splice(2, 0, {
                ...sidewalkBench,
                variantString: 'right',
                variant: { 'bench-orientation': 'right' },
                id: nanoid()
              })
            }

            // if transit has shelter
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[1])
            ) {
              toBeAddedSegments.splice(2, 0, {
                ...shelter,
                variantString: 'right|street-level',
                variant: {
                  orientation: 'right',
                  'transit-shelter-elevation': 'street-level'
                },
                id: nanoid()
              })
            }
          **/
            }
            const insertAtIndex = lastLandeIndex + 1

            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              insertAtIndex,
              segmentCopy
            )
          } else if (
            pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[1]
          ) {
            // Attached sidewalk + with lamp + lastlane

            let toBeAddedSegments = []
            // ------ COMMENT OUT LIGHTING
            // if (lighting === LIGHTING_VALUES[0]) {
            //   // Pedestrian Lamp
            //   toBeAddedSegments = [
            //     {
            //       ...rightLamp,
            //       id: nanoid()
            //     },
            //     { ...sidewalk, id: nanoid() }
            //   ]
            // } else if (lighting === LIGHTING_VALUES[1]) {
            //   // Road Lamp
            //   toBeAddedSegments = [
            //     {
            //       ...lefttLamp,
            //       id: nanoid(),
            //       variantString: 'left|modern',
            //       variant: { ...lefttLamp.variant, 'lamp-type': 'modern' }
            //     },
            //     { ...sidewalk, id: nanoid() }
            //   ]
            // }

            // ------ COMMENT OUT ALL TRANSIT AMENITIES
            {
              /**
            // if transit has bike rack
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[8])
            ) {
              toBeAddedSegments = [
                ...toBeAddedSegments,
                {
                  ...bikeRack,
                  variantString: 'left|sidewalk-parallel',
                  variant: {
                    orientation: 'left',
                    'bike-rack-elevation': 'sidewalk-parallel'
                  },
                  id: nanoid()
                }
              ]
            }
            // if transit has Bench
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[7])
            ) {
              toBeAddedSegments = [
                ...toBeAddedSegments,
                {
                  ...sidewalkBench,
                  variantString: 'left',
                  variant: { 'bench-orientation': 'left' },
                  id: nanoid()
                }
              ]
            }

            // if transit has shelter
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[1])
            ) {
              toBeAddedSegments = [
                ...toBeAddedSegments,
                {
                  ...shelter,
                  variantString: 'left|street-level',
                  variant: {
                    orientation: 'left',
                    'transit-shelter-elevation': 'street-level'
                  },
                  id: nanoid()
                }
              ]
            }
          **/
            }
            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              lastLandeIndex + 1,
              segmentCopy
            )
          }
        } else {
          // NO lamp + Detahced sidewalk
          if (pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[0]) {
            const toBeAddedSegments = [
              { ...plantingStrip, id: nanoid() },
              { ...sidewalk, id: nanoid() }
            ]

            // ------ COMMENT OUT ALL TRANSIT AMENITIES
            {
              /**
            // if transit has bike rack
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[8])
            ) {
              toBeAddedSegments.splice(1, 0, {
                ...bikeRack,
                variantString: 'right|sidewalk-parallel',
                variant: {
                  orientation: 'right',
                  'bike-rack-elevation': 'sidewalk-parallel'
                },
                id: nanoid()
              })
            }
            // if transit has Bench
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[7])
            ) {
              toBeAddedSegments.splice(1, 0, {
                ...sidewalkBench,
                variantString: 'right',
                variant: { 'bench-orientation': 'right' },
                id: nanoid()
              })
            }
            // if transit has shelter
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[1])
            ) {
              toBeAddedSegments.splice(1, 0, {
                ...shelter,
                variantString: 'right|street-level',
                variant: {
                  orientation: 'right',
                  'transit-shelter-elevation': 'street-level'
                },
                id: nanoid()
              })
            }
            **/
            }
            const insertAtIndex = lastLandeIndex + 1

            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              insertAtIndex,
              segmentCopy
            )
          } else if (
            pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[1]
          ) {
            // NO lamp + Attached sidewalk + lastlane

            let toBeAddedSegments = [{ ...sidewalk, id: nanoid() }]

            // ------ COMMENT OUT ALL TRANSIT AMENITIES
            {
              /**
            // if transit has bike rack
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[8])
            ) {
              toBeAddedSegments = [
                ...toBeAddedSegments,
                {
                  ...bikeRack,
                  variantString: 'right|sidewalk-parallel',
                  variant: {
                    orientation: 'right',
                    'bike-rack-elevation': 'sidewalk-parallel'
                  },
                  id: nanoid()
                }
              ]
            }
            // if transit has bench
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[7])
            ) {
              toBeAddedSegments = [
                ...toBeAddedSegments,
                {
                  ...sidewalkBench,
                  variantString: 'right',
                  variant: { 'bench-orientation': 'right' },
                  id: nanoid()
                }
              ]
            }
            // if transit has shelter
            if (
              transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[1])
            ) {
              toBeAddedSegments = [
                ...toBeAddedSegments,
                {
                  ...shelter,
                  variantString: 'right|street-level',
                  variant: {
                    orientation: 'right',
                    'transit-shelter-elevation': 'street-level'
                  },
                  id: nanoid()
                }
              ]
            }

            **/
            }
            segmentCopy = addMultipleSegments(
              toBeAddedSegments,
              lastLandeIndex + 1,
              segmentCopy
            )
          }
        }
        // if bike has buffer, and sidewalk is Detached
        if (
          bikeLaneHasBuffer &&
          pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[0]
        ) {
          const buffer = {
            type: 'divider',
            variantString: 'striped-buffer',
            width: 6
          }
          const firstBikeLaneIndex = segmentCopy.findIndex(
            (segment) => segment?.type === 'bike-lane'
          )

          segmentCopy = addSegment(
            bike_facility_type === BIKE_FACILITY_TYPE_VALUES[2]
              ? firstBikeLaneIndex + 1
              : firstBikeLaneIndex + 2,
            { ...buffer, id: nanoid() },
            segmentCopy
          )
          if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[2]) {
            // Reverse segments to find last lane id
            const copyOfSegmentsToReverse = [...segmentCopy]

            const lastBikeLaneId = copyOfSegmentsToReverse
              .reverse()
              .find((segment) => segment?.type === 'bike-lane')?.id

            const lastBikeLandeIndex = segmentCopy.findIndex(
              (segment) => segment?.id === lastBikeLaneId
            )

            segmentCopy = addSegment(
              lastBikeLandeIndex,
              { ...buffer, id: nanoid() },
              segmentCopy
            )
          }
        }

        // Combine all extra planting strips
        segmentCopy = combineAdjacentPlantingStrips(segmentCopy)

        updateFinalStreet(segmentCopy)
        // // If bike lane buffer was removed, add it back
        // if (bikeLaneHasBuffer) {
        //   console.log(bikeLaneHasBuffer)
        //   store.dispatch(
        //     setBicycleInputs({
        //       field: BIKE_FACILITY_TYPE,
        //       value: bikeLaneHasBuffer
        //     })
        //   )
        // }
        // setbikeStreetmixInput(BIKE_FACILITY_TYPE)
      }

      break

    case COMFORT_ZONE_WIDTH:
      // Check if input is NO Sidewalk

      let segmentCopy = cloneDeep(segments)

      // Check if there are sidewalks, if there is no sidewalk do not update the street
      if (
        segmentCopy.some((segment) => segment?.type === 'sidewalk') === true
      ) {
        // Get all sidewalk segments
        const sidewalksIdArr = segmentCopy
          .filter((segment) => segment?.type === 'sidewalk')
          .map((segment) => segment?.id)

        if (comfort_zone_width === COMFORT_ZONE_WIDTH_VALUES[0]) {
          // set all sidewalk width to 6 ft
          segmentCopy = segmentCopy.map((segment) => {
            // if sidewalk then,reset width
            if (sidewalksIdArr.includes(segment?.id)) {
              return { ...segment, width: 6 }
            } else {
              return segment
            }
          })
        } else if (comfort_zone_width === COMFORT_ZONE_WIDTH_VALUES[1]) {
          // set all sidewalk width to 5.5 ft
          segmentCopy = segmentCopy.map((segment) => {
            // if sidewalk then,reset width
            if (sidewalksIdArr.includes(segment?.id)) {
              return { ...segment, width: 5.5 }
            } else {
              return segment
            }
          })
        }
        updateFinalStreet(segmentCopy)
      }

      break
    case LIGHTING:
      // ------ COMMENT OUT LIGHTING
      // Check if input is "No Lighting"
      // if (lighting === LIGHTING_VALUES[2]) {
      //   let segmentCopy = cloneDeep(segments)
      //   segmentCopy = removeAllSimilarSegmentNames(segmentCopy, 'lamp')

      //   // Combine all extra planting strips
      //   segmentCopy = combineAdjacentPlantingStrips(segmentCopy)

      //   updateFinalStreet(segmentCopy)
      // } else if (
      //   lighting === LIGHTING_VALUES[0] ||
      //   lighting === LIGHTING_VALUES[1]
      // ) {
      //   // Check if segment already has sidewalk, if it does just move the sidewalk
      //   let segmentCopy = cloneDeep(segments)
      //   segmentCopy = removeAllSimilarSegmentNames(segmentCopy, 'lamp')

      //   const rightLamp = {
      //     type: 'sidewalk-lamp',
      //     variant: {
      //       'lamp-orientation': 'right',
      //       'lamp-type': 'modern'
      //     },
      //     variantString: 'right|modern',
      //     width: 2,
      //     elevation: 1
      //   }
      //   const lefttLamp = {
      //     type: 'sidewalk-lamp',
      //     variant: {
      //       'lamp-orientation': 'left',
      //       'lamp-type': 'modern'
      //     },
      //     variantString: 'left|modern',
      //     width: 2,
      //     elevation: 1
      //   }
      //   let isBufferQuality = false
      //   if (
      //     buffer_quality === BUFFER_QUALITY_VALUES[0] ||
      //     buffer_quality === BUFFER_QUALITY_VALUES[1] ||
      //     buffer_quality === BUFFER_QUALITY_VALUES[2]
      //   ) {
      //     isBufferQuality = true
      //   }

      //   let firstLaneIndex = segmentCopy.findIndex(
      //     (segment) =>
      //       segment?.type?.indexOf('lane') !== -1 &&
      //       segment?.type?.indexOf('parking-lane') === -1
      //   )
      //   const isSidewalkDetached =
      //     pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[0]

      //   // If lanes do not exist
      //   if (firstLaneIndex === -1) {
      //     // if lanes do not exsist add the lanes
      //     const driveLane = {
      //       type: 'drive-lane',
      //       width: 10,
      //       variantString: 'inbound|car',
      //       variant: {
      //         direction: 'inbound',
      //         'car-type': 'car'
      //       },
      //       elevation: 0
      //     }
      //     const toBeAddedSegments = [
      //       { ...driveLane, id: nanoid() },
      //       {
      //         ...driveLane,
      //         variantString: 'outbound|car',
      //         variant: { ...driveLane.variant, direction: 'outbound' },
      //         id: nanoid()
      //       }
      //     ]
      //     segmentCopy = addMultipleSegments(
      //       toBeAddedSegments,
      //       Math.floor(segmentCopy.length / 2),
      //       segmentCopy
      //     )

      //     // since new lanes are added, update first lane index
      //     firstLaneIndex = segmentCopy.findIndex(
      //       (segment) =>
      //         segment?.type?.indexOf('lane') !== -1 &&
      //         segment?.type?.indexOf('parking-lane') === -1
      //     )
      //   }
      //   // Add lamp near first  lane, pedestrian lamp
      //   if (lighting === LIGHTING_VALUES[0]) {
      //     const index = isSidewalkDetached
      //       ? firstLaneIndex - 1 === -1
      //         ? 0
      //         : firstLaneIndex - 1
      //       : firstLaneIndex
      //     segmentCopy = addSegment(
      //       index,
      //       {
      //         ...lefttLamp,
      //         id: nanoid(),
      //         variantString: 'left|traditional',
      //         variant: { ...lefttLamp.variant, 'lamp-type': 'traditional' }
      //       },
      //       segmentCopy
      //     )
      //   } else if (lighting === LIGHTING_VALUES[1]) {
      //     // add road lamp
      //     const index =
      //       isSidewalkDetached && isBufferQuality
      //         ? firstLaneIndex - 1 === -1
      //           ? 0
      //           : firstLaneIndex - 1
      //         : firstLaneIndex
      //     segmentCopy = addSegment(
      //       index,
      //       { ...rightLamp, id: nanoid() },
      //       segmentCopy
      //     )
      //   }

      //   // Reverse segments to find last lane id
      //   const copyOfSegmentsToReverse = [...segmentCopy]

      //   const lastLaneId = copyOfSegmentsToReverse
      //     .reverse()
      //     .find(
      //       (segment) =>
      //         segment?.type?.indexOf('lane') !== -1 &&
      //         segment?.type?.indexOf('parking-lane') === -1
      //     )?.id

      //   const lastLandeIndex = segmentCopy.findIndex(
      //     (segment) => segment?.id === lastLaneId
      //   )

      //   // Add lamp near first  lane, pedestrian lamp
      //   if (lighting === LIGHTING_VALUES[0]) {
      //     const index = isSidewalkDetached
      //       ? lastLandeIndex + 2
      //       : lastLandeIndex + 1
      //     segmentCopy = addSegment(
      //       index,
      //       {
      //         ...rightLamp,
      //         id: nanoid(),
      //         variantString: 'right|traditional',
      //         variant: { ...rightLamp.variant, 'lamp-type': 'traditional' }
      //       },
      //       segmentCopy
      //     )
      //   } else if (lighting === LIGHTING_VALUES[1]) {
      //     // add road lamp
      //     const index =
      //       isSidewalkDetached && isBufferQuality
      //         ? lastLandeIndex + 2
      //         : lastLandeIndex + 1
      //     segmentCopy = addSegment(
      //       index,
      //       { ...lefttLamp, id: nanoid() },
      //       segmentCopy
      //     )
      //   }
      //   // Combine all extra planting strips
      //   segmentCopy = combineAdjacentPlantingStrips(segmentCopy)

      //   updateFinalStreet(segmentCopy)
      // } else if (
      //   PTier === 0 &&
      //   !transit_stop_amenities.includes(TRANSIT_STOP_AMENITIES_VALUES[2])
      // ) {
      //   let segmentCopy = cloneDeep(segments)
      //   segmentCopy = removeAllSimilarSegmentNames(segmentCopy, 'lamp')

      //   updateFinalStreet(segmentCopy)
      // }
      break
    case CROSSING_IMPROVEMENTS:
      // Modify segment if Median is selected
      // if (crossing_improvements.includes(CROSSING_IMPROVEMENTS_VALUES[1])) {
      //   let segmentCopy = cloneDeep(segments)
      //   segmentCopy = removeAllMatchingSegmentsWithVariant(
      //     segmentCopy,
      //     'divider',
      //     'median'
      //   )

      //   const median = {
      //     type: 'divider',
      //     variantString: 'median',
      //     width: 4
      //   }

      //   segmentCopy = addSegment(
      //     segments.length / 2,
      //     { ...median, id: nanoid() },
      //     segmentCopy
      //   )

      //   updateFinalStreet(segmentCopy)

      //   // Insert median in the between the lanes
      // } else if (
      //   !crossing_improvements.includes(CROSSING_IMPROVEMENTS_VALUES[1])
      // ) {
      //   // Remove Median if un-selected
      //   let segmentCopy = cloneDeep(segments)
      //   segmentCopy = removeAllMatchingSegmentsWithVariant(
      //     segmentCopy,
      //     'divider',
      //     'median'
      //   )

      //   updateFinalStreet(segmentCopy)
      // }
      break
    default:
  }
}
function removeAllMatchingSegmentsWithVariantAndWidth(
  segmentCopy,
  segmentType,
  segmentVariant,
  width
) {
  // get all macthing segments indexes
  const sidewalkIndexArr = segmentCopy
    .map((segment, index) => {
      if (
        segment.type === segmentType &&
        segment.variantString === segmentVariant &&
        segment.width <= width
      ) {
        return index
      } else {
        return null
      }
    })
    .filter((index) => index !== null)
  return segmentCopy.filter(
    (segment, index) => !sidewalkIndexArr.includes(index)
  )
}

function combineAdjacentPlantingStrips(segmentCopy) {
  const { street } = store.getState()
  const adjacentStripIndex = []
  segmentCopy = segmentCopy.map((segment, index) => {
    if (
      segment.variantString === 'planting-strip' &&
      segmentCopy[index + 1]?.variantString === 'planting-strip'
    ) {
      adjacentStripIndex.push(index + 1)
      return {
        ...segment,
        width: segment.width + segmentCopy[index + 1]?.width
      }
    } else {
      return segment
    }
  })
  segmentCopy = segmentCopy.filter(
    (segment, index) => !adjacentStripIndex.includes(index)
  )
  const totalSegmentWidth = segmentCopy.reduce(
    (totalWidth, segment) => totalWidth + segment.width,
    0
  )

  const diffInWidth = totalSegmentWidth - street.width
  let longestPlantingStripWidth = 0
  segmentCopy.forEach((segment) => {
    if (
      segment.variantString === 'planting-strip' &&
      segment.width > longestPlantingStripWidth
    ) {
      longestPlantingStripWidth = segment.width
    }
  })
  if (totalSegmentWidth > street.width) {
    // adjust width of that detached sidewalk
    segmentCopy = segmentCopy.map((segment, index) => {
      if (
        segment.variantString === 'planting-strip' &&
        segment.width === longestPlantingStripWidth
      ) {
        return {
          ...segment,
          width: segment.width - Math.round((diffInWidth / 2) * 1000) / 1000
        }
      } else {
        return segment
      }
    })
  } else if (totalSegmentWidth < street.width) {
    if (
      segmentCopy.some(
        (segment) => segment?.variantString === 'planting-strip'
      ) === true
    ) {
      // if there are planting strips
      // if there is some space in the street, add it to the planting strip
      segmentCopy = segmentCopy.map((segment, index) => {
        if (
          segment.variantString === 'planting-strip' &&
          segment.width === longestPlantingStripWidth
        ) {
          return {
            ...segment,
            width:
              segment.width +
              Math.abs(Math.round((diffInWidth / 2) * 1000) / 1000)
          }
        } else {
          return segment
        }
      })
    } else {
      // if there are no planting strips
      const plantingStrip = {
        type: 'divider',
        variantString: 'planting-strip',
        width: 4,
        elevation: 1
      }
      segmentCopy = addSegment(
        0,
        {
          ...plantingStrip,
          width: Math.abs(Math.round((diffInWidth / 2) * 1000) / 1000),
          id: nanoid()
        },
        segmentCopy
      )
      segmentCopy = addSegment(
        segmentCopy.length,
        {
          ...plantingStrip,
          width: Math.abs(Math.round((diffInWidth / 2) * 1000) / 1000),
          id: nanoid()
        },
        segmentCopy
      )
    }
  }
  return segmentCopy
}
